import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="event-page"
export default class extends Controller {
  static targets = ["form", "url", "afterUrl", "urlAvailable", "submit"];

  connect() {
    if (this.hasUrlTarget) {
      this.setAfterUrl();
    }
    this.controller = null;
    this.errorMassages = [];
  }

  // 変更後のURLを表示
  setAfterUrl() {
    const url = this.urlTarget.value;
    this.afterUrlTargets.forEach((target) => {
      target.textContent = url;
    });
  }

  // 送信ボタン 有効化/無効化
  toggleSubmitButton(isAvailable) {
    this.submitTarget.disabled = !isAvailable;
    this.submitTarget.setAttribute("aria-disabled", String(!isAvailable));
  }

  urlFieldClass(isAvailable) {
    this.urlTarget.classList.toggle("is-error", !isAvailable);
  }

  // 利用可能表示切り替え
  updateUrlStatus(isAvailable) {
    const message = isAvailable ? "利用できます。" : "利用できません。";
    const addClass = isAvailable ? "form-text-ok" : "form-error-text";
    const removeClass = isAvailable ? "form-error-text" : "form-text-ok";

    this.urlAvailableTarget.style.display = "block";
    this.urlAvailableTarget.textContent = message;
    this.urlAvailableTarget.classList.remove(removeClass);
    this.urlAvailableTarget.classList.add(addClass);
    this.toggleSubmitButton(isAvailable);
    this.urlFieldClass(isAvailable);
  }

  // エラーメッセージ表示切り替え
  updateErrorMasage(isAvailable) {
    const error = document.getElementById("error-message");
    const messageList = error.querySelector("ul.message-list");
    messageList.innerHTML = "";
    this.errorMassages.forEach(function (message) {
      messageList.insertAdjacentHTML("beforeend", "<li class='message-list__item'>" + message + "</li>");
    });
    error.hidden = isAvailable;
  }

  preventSubmit(event) {
    if (event.key !== "Enter") return;
    // ボタン要素を取得
    const btn = this.submitTarget;
    const isEnabled = btn.getAttribute("aria-disabled") === "false";
    if (isEnabled) {
      // ボタンが有効ならモーダル表示
      event.preventDefault();
      btn.click();
    } else {
      // 無効なら送信しない
      event.preventDefault();
    }
  }

  nameValidation(name) {
    if (name.length === 0) {
      this.errorMassages.push("ページ名を入力してください。");
      return false;
    } else if (name.length < 6) {
      this.errorMassages.push("ページ名は6文字以上で入力してください。");
    } else if (name.length > 32) {
      this.errorMassages.push("ページ名は32文字以内で入力してください。");
    }
    const characterTypePattern = /^[a-z0-9\-_]+$/;
    if (!characterTypePattern.test(name)) {
      this.errorMassages.push("ページ名は半角小文字英数字と「-」「_」で入力してください。");
    } else if (name.startsWith("-") || name.startsWith("_")) {
      this.errorMassages.push("ページ名の先頭文字に「-」「_」は使用できません。");
    }

    return this.errorMassages.length === 0;
  }

  // URLが利用可能かチェック
  checkUrl(event) {
    // すでにコントローラーが存在する場合、前回のリクエストをキャンセル
    if (this.controller) {
      this.controller.abort();
    }
    // 新しいAbortControllerを作成
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.errorMassages = [];

    let queryParams = new URLSearchParams({
      name: event.currentTarget.value,
    }).toString();

    this.setAfterUrl();
    if (this.nameValidation(event.currentTarget.value)) {
      let baseUrl = event.currentTarget.form.dataset.checkUrl;
      fetch(`${baseUrl}?${queryParams}`, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').getAttribute("content"),
        },
        signal: signal, // キャンセル用の信号を指定
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("HTTP error! status: " + response.status);
          }
          return response.json();
        })
        .then((data) => {
          if (data.available) {
            this.errorMassages = [];
            this.updateUrlStatus(true);
            this.updateErrorMasage(true);
          } else {
            this.errorMassages = data.error_messages;
            this.updateUrlStatus(false);
            this.updateErrorMasage(false);
          }
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.error("エラーが発生しました:", error);
            window.location.reload();
          }
        });
    } else {
      this.updateUrlStatus(false);
      this.updateErrorMasage(false);
    }
  }

  // フォーム送信
  /** @deprecated 使用していないはず */
  submit() {
    const form = this.formTarget;
    form.requestSubmit();
  }
}
